import styled, { css } from 'styled-components';
import { Skeleton } from 'antd';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import ModalAntd from '@deprecated-ui/common/Modal';
import Input from '@deprecated-ui/common/Input';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import {
  LiveLabelContainerProps,
  LiveTitleContainerProps,
  ModalProps,
  TextareaProps,
} from './types';

const { TextArea } = Input;

const ContainerBackground = {
  EVENT_STATUS_UPCOMING: '#4f4be8',
  EVENT_STATUS_LIVE:
    'linear-gradient(255.44deg, #4F4BE8 -2.84%, #9042E1 158.53%)',
  EVENT_STATUS_ENDED:
    'linear-gradient(255.44deg, #4f4be8 -2.84%, #9042e1 158.53%)',
};

const Wrapper = styled.div`
  left: 0px;
  right: 0px;
  position: absolute;
  margin-right: 37px;

  background: ${color.light};
  height: 100%;
  overflow: scroll;
  margin: auto;

  @media ${device.tablet} {
    position: relative;
    padding: 0 20px;
    overflow: unset;
  }

  @media ${device.laptop} {
    padding: 0 40px;
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding-bottom: 0;
  gap: 40px;
  display: flex;
  justify-content: center;
  max-width: 100%;
  min-width: auto;

  // Hide scroll
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none;
  }

  @media ${device.laptop} {
    max-height: calc(100vh - 100px);
    margin: auto;
    flex-direction: row;
  }
`;

const StreamBoxLeftWrapper = styled.div`
  width: 100%;
  max-width: 760px;
  height: 100%;
  margin: 0;
  flex-direction: column-reverse;
  display: flex;
  gap: 30px;

  & > #livestream-widget-host-detail {
    display: none;
  }

  @media ${device.laptop} {
    display: flex;
    max-width: 760px;
    flex-direction: column;
    padding: 60px 0;
    width: 100%;
    height: 100%;

    & > #livestream-widget-host-detail {
      display: flex;
    }
  }
`;

const PlayerHeaderContainer = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})<LiveTitleContainerProps>`
  background: ${({ status }) => ContainerBackground[status]};
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  @media ${device.tablet} {
    max-width: 650px;
  }

  @media ${device.laptop} {
    margin-bottom: unset;
    max-width: unset;
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 12px;
  }
`;

const EventBadgeContainer = styled(Flex).attrs({
  align: 'center',
})<LiveLabelContainerProps>`
  background: ${({ status }) =>
    status === 'EVENT_STATUS_LIVE' ? color.sunsetOrange : 'rgba(0,0,0,.2)'};
  width: auto;
  padding: 2.5px 8px;
  border-radius: 10px;
`;

const VideoPlayerContainer = styled.div`
  position: relative;
`;

const BannerContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const StreamBoxRightWrapper = styled.div`
  width: auto;
  margin: 0 20px;
  gap: 20px;

  & > #livestream-widget-host-detail {
    margin-top: 20px;
  }

  @media ${device.tablet} {
    width: 100%;
    max-width: 650px;
  }

  @media ${device.laptop} {
    width: 264px;
    margin: 0px;

    display: flex;
    flex-direction: column;
    padding-top: 60px;
    position: sticky;
    top: 0;

    & > #livestream-widget-host-detail {
      display: none;
    }
  }
`;

const WidgetHostContainer = styled(Flex)`
  padding: 16px;
  border-radius: 6px;
  border: 1px solid ${color.downgray};
`;

const HostLogo = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  border: 0.5px solid ${color.downgray};

  img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
  }
`;

const HostDetail = styled(Flex).attrs({
  direction: 'column',
})`
  padding-left: 12px;
`;

const WidgetInfoActionContainer = styled.div`
  border: 0.5px solid ${color.downgray};
  border-radius: 6px;
  padding: 16px;
  margin-top: 20px;

  @media ${device.laptop} {
    margin-top: unset;
  }
`;

const IconContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  border-radius: 100%;
  width: 32px;
  height: 32px;
  background: #e6fcef;
  margin-right: 12px;
`;

const Divider = styled.div`
  border-top: 1px solid ${color.downgray};
  width: 100%;
  margin: 20px 0;
`;

const ButtonUnstyled = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: min-content;
  overflow: visible;
  background: transparent;
  cursor: pointer;

  :hover {
    background: transparent;
  }
`;

const LivePlayerButton = styled(ButtonUnstyled)`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  opacity: 0.4;
  display: flex;
  align-items: center;
  :hover {
    opacity: 0.7;
  }
`;

const Modal = styled(ModalAntd)<ModalProps>`
  .ant-modal-content {
    border-radius: 3px;
    min-height: ${({ isResult }) => (isResult ? '295px' : '346px')};
    display: flex;
    flex-direction: column;
  }
  .ant-modal-header {
    border-color: ${color.gainsboro};
    border-radius: 3px 3px 0 0;
    height: 66px;
    padding: 0 20px !important;

    .ant-modal-title {
      padding: 20px 0;
    }
  }
  .ant-modal-body {
    padding: 10px 20px 20px 20px;
    border-radius: 0 0 3px 3px;
    display: flex;
    flex-direction: column;
    -webkit-box-flex: 1;
    flex: 1 1 auto;

    div {
      display: flex;
      flex-direction: column;
      -webkit-box-flex: 1;
      flex: 1 1 auto;
    }
  }
  .ant-modal-footer {
    padding: 0 !important;
    text-align: left;
    display: flex;
  }
  .ant-modal-close {
    top: 20px;
    right: 20px;

    .ant-modal-close-x {
      width: 25px;
      height: 25px;
      line-height: 25px;
      font-size: 18px;
    }
  }
`;

const InputGroup = styled.div`
  max-width: 300px;
  width: 100%;
  margin: 10px auto;
  position: relative;
`;

const Label = styled(Text).attrs({
  size: '14px',
  height: '19px',
})`
  font-size: 14px;
  position: absolute;
  margin-top: 6px;
  z-index: 1;
  transition: 0.3s ease all;
  ${({ color: textColor }) =>
    textColor &&
    css`
      color: ${textColor} !important;
    `}
`;

const Textarea = styled(TextArea).attrs({
  autoSize: { minRows: 1, maxRows: 6 },
})<TextareaProps>`
  border: none;
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: 0.5px solid;
  border-color: ${({ matchMaxChar }) =>
    matchMaxChar ? color.sunsetOrange : color.midgray} !important;

  &:not(:empty) {
    border-color: ${({ matchMaxChar }) =>
      matchMaxChar ? color.sunsetOrange : color.primary} !important;
  }

  &:focus {
    border-color: ${({ matchMaxChar }) =>
      matchMaxChar ? color.sunsetOrange : color.primary} !important;
  }

  &:not(:empty) ~ ${Label} {
    font-size: 12px;
    margin-top: -20px;
  }

  &:not(:empty) ~ ${Label}[color="${color.midgray}"] {
    color: ${color.primary} !important;
  }

  &:focus ~ ${Label}[color="${color.midgray}"] {
    font-size: 12px;
    margin-top: -20px;
    color: ${color.primary} !important;
  }
`;

const ModalQuestionContent = styled(Flex).attrs({
  direction: 'column',
  align: 'space-between',
})`
  flex-direction: column;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
`;

const ButtonSubmitQuestion = styled(Button).attrs({
  type: 'primary',
  width: '100%',
  height: '42px',
  radius: '4px',
})`
  font-family: var(--bold-font);
  :disabled {
    background: #7dd2b2;
    color: ${color.light};
    border: none;
  }
`;

const ShimmerBoxLeft = styled.div`
  padding: 20px;
  border: 1px solid ${color.downgray};
  border-radius: 6px;
  width: 100%;

  @media ${device.laptop} {
    width: 856px !important;
    margin-right: 48px;
    display: content;

    & > :nth-child(2) {
      height: 100%;
    }
  }
`;

const ShimmerRightWidget = styled(StreamBoxRightWrapper)`
  padding: 20px;
  margin-bottom: 40px;
  border: 1px solid ${color.downgray};
  border-radius: 6px;
`;

const ShimmerPlayer = styled(Skeleton.Button)`
  display: flex;
  .ant-skeleton-button {
    width: 100%;
    height: 428px;
  }
`;

const ShimmerTitle = styled(Skeleton.Button).attrs({
  size: 'small',
  active: true,
})`
  margin-bottom: 5px;
  .ant-skeleton-button {
    width: 200px;
  }
`;

const ShimmerItem = styled(Skeleton).attrs({
  active: true,
})`
  .ant-skeleton-title {
    margin: 0px !important;
    height: 20px;
    width: 100% !important;
  }
  .ant-skeleton-paragraph {
    margin-top: 5px !important;
    li {
      height: 10px;
      margin-top: 10px !important;
    }
    & > :first-child {
      width: 30%;
      height: 15px !important;
    }
  }
`;

const YoutubeContainer = styled.div`
  background: linear-gradient(90deg, #eee 8%, #f0f0f0 18%, #eee 33%);
  border-radius: 6px;
  position: relative;
  padding-bottom: 56.25%;
  height: 100%;
  overflow: hidden;
  max-height: 426px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media ${device.tablet} {
    iframe {
      border-radius: 6px;
    }
  }
`;

const PlayerBannerContainer = styled.div`
  padding-bottom: 51.448%;
  background: linear-gradient(90deg, #eee 8%, #f0f0f0 18%, #eee 33%);
  width: 100%;
  position: relative;
  overflow: hidden;
  max-height: 200px;

  #livestream-banner-image-cover {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
  }

  @media ${device.laptop} {
    border: 1px solid #ededed;
    border-radius: 6px;

    #livestream-banner-image-cover {
      left: 0;
      top: 0;
    }

    img {
      border-radius: 6px;
    }
  }

  @media ${device.laptopL} {
    max-height: 400px;
  }
`;

const ButtonReload = styled.button`
  background: ${color.light};
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: ${color.primary};
  font-family: var(--font-bold);
  border: 1px solid ${color.downgray};
  padding: 12px 16px;
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
`;

export {
  Wrapper,
  Container,
  StreamBoxLeftWrapper,
  PlayerHeaderContainer,
  VideoPlayerContainer,
  BannerContainer,
  StreamBoxRightWrapper,
  WidgetHostContainer,
  EventBadgeContainer,
  HostLogo,
  HostDetail,
  WidgetInfoActionContainer,
  IconContainer,
  Divider,
  ButtonUnstyled,
  Modal,
  InputGroup,
  Textarea,
  ModalQuestionContent,
  ButtonSubmitQuestion,
  Label,
  LivePlayerButton,
  ShimmerBoxLeft,
  ShimmerRightWidget,
  ShimmerPlayer,
  ShimmerTitle,
  ShimmerItem,
  YoutubeContainer,
  PlayerBannerContainer,
  ButtonReload,
};
